<template>
  <el-form ref="form" :model="formData" size="small">
    <el-row>
      <el-form-item :label="$l('INDEX.table_label_remarks') || '备注说明'">
        <el-input
          v-model="formData.remark"
          :placeholder="
            $l('INDEX.order_form_ple_tech_doc_remark') || '请输入备注说明'
          "
          type="textarea"
          :maxlength="250"
          show-word-limit
        >
        </el-input>
      </el-form-item>
    </el-row>
    <el-row>
      <el-upload
        drag
        action="#"
        multiple
        :file-list="listFile"
        :auto-upload="false"
        :limit="uploadLimit"
        :on-exceed="onFileExceed"
        :on-change="onFileChange"
        :on-remove="onFileChange"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或'
          }}<em> {{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
        </div>
      </el-upload>
    </el-row>
  </el-form>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    uploadLimit: { type: Number, default: 5 },
  },
  data() {
    return {
      formData: { remark: '' },
      listFile: [],
    }
  },
  methods: {
    onFileChange(files, fileList) {
      this.listFile = fileList
    },
    onFileExceed(files, fileList) {
      this.$message.warning(
        (this.$l('INDEX.tips_limit_selection') || '限制选择') +
          `  ${this.uploadLimit}  ` +
          (this.$l('INDEX.tips_file') || '文件') +
          ',' +
          (this.$l('INDEX.tips_selected_this_time') || '本次选择了') +
          `  ${files.length}  ` +
          (this.$l('INDEX.tips_file') || '文件') +
          ',' +
          (this.$l('INDEX.tips_a_total_of') || '共选择了') +
          `  ${files.length + fileList.length}  ` +
          this.$l('INDEX.tips_file') || '文件'
      )
    },
    async upload() {
      if (!this.listFile || !this.listFile.length) {
        this.$message({
          message: '请选择费用相关文档',
          type: 'warning',
        })
        return false
      }
      this.loadingOpen()
      const listDoc = await this.uploadFiles()
      this.loadingClose()
      if (!listDoc || !listDoc.length) {
        this.$message({
          message: '费用相关文档上传失败',
          type: 'warning',
        })
        return false
      }

      if (listDoc.length !== listDoc.filter(Boolean).length) {
        this.$message({
          message: '费用相关文档上传失败',
          type: 'warning',
        })
        return false
      }

      return { listDoc, ...this.formData }
    },
    uploadFiles() {
      if (!this.listFile || !this.listFile.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listFile.map((file) => {
        return this.$api
          .SYS_UPLOAD(file.raw)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileName: file.name,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
  },
}
</script>

<style scoped></style>
